import {
    Dialog,
    DialogContent,
    DialogContentText,
    createStyles,
    makeStyles,
    useMediaQuery,
    useTheme
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import {
    HarmonisedDialogTitle,
    HarmonisedModalActions
} from '../../Common/UI';
import { useForm } from 'react-hook-form';
import { connect, useSelector } from 'react-redux';
import { CommonDispatcher, OpenModal } from '../../../redux/Common/action';
import { GetUsersList, UpdateUserProfile } from '../../../redux/Users/actions';
import { RootState } from '../../../redux/store';

import { useCookies } from 'react-cookie';
import { ADD_ADDRESS_BOOK_NOTE_MODAL } from '../../../redux/ModalReducer/actionTypes';
import EditorComponent from '../../InputComponents/Editor';
import { SHOW_SNACKBAR } from '../../../redux/Common/actionTypes';
import { UpdateFirm, GetFirmsList } from '../../../redux/Firms/actions';
import { useHistory, useLocation } from 'react-router-dom';
import { FirmsTab, Routes } from '../../../constants';
import { getQuery } from '../../../utils/common';

const useStyles = makeStyles(() =>
    createStyles({
        dialogContainer: { maxWidth: '700px' },
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& > *': {
                flex: '1 1 30%',
                margin: 'auto'
            }
        }
    })
);

const AddAdressBookSaveSignatureModal = ({
    OpenModal,
    UpdateUserProfile,
    GetUsersList,
    CommonDispatcher,
    UpdateFirm,
    GetFirmsList
}) => {
    const state = useSelector((store: RootState) => store);
    const modal: any = state?.modal?.addAdressbookNoteModal;
    const modalData: any = modal?.data?.data?.address_book;
    const [isLoading, setLoading] = useState(false);
    const [note, setNote] = useState();
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    // console.log('messageId', modal.data.profile);
    const [cookies] = useCookies(['pgAdminToken']);
    const token = cookies['pgAdminToken'];
    const blankDescription = '<p><br></p>';
    const history = useHistory();
    const location = useLocation();

    const query = getQuery(history);
    const queryParams = new URLSearchParams(location.search);
    const filterParam = queryParams.get('filter');
    const filterKeyword = queryParams.get('keyword');
    const filterType = queryParams.get('type');

    const filterTags = queryParams.get('tags_ids');
    let filter: any = {};
    let keyword;
    let type;
    if (filterParam) {
        filter = { ...filter, ...JSON.parse(decodeURIComponent(filterParam)) };
    }

    const tagsIdsArray = filterTags
        ? filterTags.split(',').map((id) => parseInt(id))
        : [];

    if (tagsIdsArray.length > 0) {
        filter.tags_ids = tagsIdsArray;
    }

    if (filterKeyword) {
        keyword = filterKeyword;
    }
    if (filterType) {
        type = filterType;
    }

    const {
        control,
        getValues,
        reset,
        formState: { isValid }
    } = useForm({
        mode: 'onChange'
    });

    useEffect(() => {
        reset({
            note: modalData?.note
        });
    }, []);

    const handleClose = () => {
        OpenModal(ADD_ADDRESS_BOOK_NOTE_MODAL, { isOpen: false });
    };
    const handleSaveSignature = () => {
        if (modalData?.user_id) {
            UpdateUserProfile(token, {
                user_id: modalData?.user_id,
                note
            }).then((response) => {
                if (response?.type === 'success') {
                    GetUsersList(token, {
                        type,
                        keyword,
                        filter: { ...filter },
                        size: 20
                    }).then(() => {
                        CommonDispatcher(SHOW_SNACKBAR, {
                            isShowing: true,
                            message: 'Settings has been updated'
                        });
                    });

                    CommonDispatcher(SHOW_SNACKBAR, {
                        isShowing: true,
                        message: 'Note updated successfully.',
                        hideAlert: true
                    });

                    setLoading(false);
                    handleClose();
                } else if (
                    response?.type === 'error' &&
                    response?.response?.data?.error
                ) {
                    CommonDispatcher(SHOW_SNACKBAR, {
                        isShowing: true,
                        message:
                            response?.response?.data?.error ||
                            'Failed to update note',
                        hideAlert: true,
                        error: true
                    });
                    setLoading(false);
                    // handleClose();
                } else {
                    CommonDispatcher(SHOW_SNACKBAR, {
                        isShowing: true,
                        message: 'Failed to update note',
                        hideAlert: true,
                        error: true
                    });
                    setLoading(false);
                    handleClose();
                }
            });
        } else {
            UpdateFirm(token, {
                firm_id: modalData?.firm_id,
                note
            }).then(() => {
                GetFirmsList(token, {
                    type,
                    is_affiliated: false,
                    tab:
                        history?.location?.pathname === Routes.firms.active
                            ? FirmsTab.TYPE_ACTIVE
                            : history?.location?.pathname ===
                              Routes.firms.inactive
                            ? FirmsTab.TYPE_IN_ACTIVE
                            : 'ALL',
                    keyword,
                    filter: { ...filter },
                    size: 20
                }).then((r) => {
                    setLoading(false);
                    handleClose();
                });
            });
        }
    };
    const handleDescriptionChange = (value: any) => {
        const isBlank = value === blankDescription;

        setNote(!isBlank ? value : null);
    };

    return (
        <Dialog
            maxWidth={'md'}
            fullScreen={fullScreen}
            fullWidth={true}
            onClose={handleClose}
            open={modal?.isOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paperScrollPaper: classes.dialogContainer }}
            disableBackdropClick={false}
        >
            <HarmonisedDialogTitle onClose={handleClose}>
                Note
            </HarmonisedDialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className=" h-40">
                        <EditorComponent
                            initialValue={modalData?.note}
                            handleDescriptionChange={handleDescriptionChange}
                            placeholder="Type your messag"
                        />
                    </div>
                </DialogContentText>
            </DialogContent>
            <HarmonisedModalActions
                onCancel={handleClose}
                cancelLabel={modal?.cancelTitle || 'Cancel'}
                onSubmit={handleSaveSignature}
                submitLabel={modal?.submitTitle || 'Ok'}
                submitDisabled={!isValid}
                submitting={isLoading}
                danger={!!modal?.isDelete}
            />
        </Dialog>
    );
};

export default connect(null, {
    OpenModal,
    UpdateUserProfile,
    GetUsersList,
    CommonDispatcher,
    UpdateFirm,
    GetFirmsList
})(AddAdressBookSaveSignatureModal);
